import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type InfiniteScrollData = {
  total: number;
};

export const initialState: InfiniteScrollData = {
  total: 0,
};

const infiniteScrollDataSlice = createSlice({
  initialState,
  name: 'inifiniteScroll',
  reducers: {
    updateTotal: (state, action: PayloadAction<number>): void => {
      state.total = action.payload;
    },
  },
});

export const { updateTotal } = infiniteScrollDataSlice.actions;

export default infiniteScrollDataSlice.reducer;
